import Vue from 'vue'

export async function getToken(context, [access_token]) {
    try {
        if (access_token) {
            context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/correos/oauth/token',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            if (response.status === 200 && response.data.access_token) {
                context.commit('setCorreosAccessToken', response.data.access_token)
                return response.data;
            }
        }

    } catch (e) {
        console.error('Error al obtener el token:', e)
    }
}

export async function getCaminos(context, [access_token, correos_access_token]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/correos/caminos',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: {
                    correos_access_token
                }
            })
            if (response.status === 200 && response.data) {
                context.commit('setCaminos', response.data)
                return response.data;
            }
        }

    } catch (e) {
        console.error('Error al obtener el token:', e)
    }
}

export async function getAlojamientosPorLocalidad(context, [access_token, correos_access_token, location_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: `/correos/accommodations/${location_id}`,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: {
                    correos_access_token
                }
            })
            if (response.status === 200 && response.data) {
                return response.data;
            }
        }

    } catch (e) {
        console.error('Error al obtener el token:', e)
    }
}

export async function getPrecioDisponibilidad(context, [access_token, correos_access_token, payload]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/correos/price',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    ...payload,
                    correos_access_token,
                }
            })
            if (response.status === 200 && response.data) {
                return response.data;
            }
        }

    } catch (e) {
        console.error('Error al obtener precio y disponibilidad:', e)
        throw e
    }
}

export async function createBooking(context, [access_token, correos_access_token, payload]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: 'correos/booking',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    ...payload,
                    correos_access_token,
                }
            })
            if (response.status === 200 || response.status === 201) {
                return response.data;
            }
        }

    } catch (e) {
        console.error('Error al crear booking:', e)
        throw e
    }
}
